import { isModerator, useViewModel } from '@utils';
import { CalendarViewModel } from '@views';
import { observer } from 'mobx-react-lite';
import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { CalendarColorsStore } from '../../store';
import '../../styles/components/filter.scss';
import { CalendarPreview } from '../calendarPreview';
import {
  BigArrowLeft, BigArrowRight, EmployeesIcon, MonthCalendarIcon, PrivateCalendarsIcon, RoomsIcon,
} from '../svgs';
import { Drawer, filterTheme } from './FilterTheme';
import { FilterViewModel } from '@components';
import { Blocks } from './components/Blocks';

export const FilterDesktop = observer(() => {
  const filterViewModel = useViewModel(FilterViewModel);
  const calendarViewModel = useViewModel(CalendarViewModel);
  const calendarColorStore = useViewModel(CalendarColorsStore);

  const [isFixedPanel, setIsFixedPanel] = useState(false);

  const handleScroll = () => setIsFixedPanel(window.scrollY > 82);

  useEffect(() => {
    filterViewModel.onInit();
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const onClickDrawer = useCallback(() => filterViewModel.setOpenPanel(true), []);

  const onClose: React.MouseEventHandler<HTMLDivElement> = useCallback((e) => {
    e.stopPropagation();
    filterViewModel.setOpenPanel(!filterViewModel.openPanel);
  }, []);

  const onChooseEmployee = useCallback((id: number) => filterViewModel.setSelectEmployee(id), []);

  const onChooseRoom = useCallback((roomNumber: number) => {
    if (roomNumber === 0) {

    }
    filterViewModel.setSelectRoom(roomNumber);
  }, []);

  const onChooseAllRooms = useCallback(() => {
    calendarViewModel.clearCalendarData();
    calendarViewModel.setSelectedFilter('day');
    calendarViewModel.setFirstDayOfIntervalAsCurrent();
    filterViewModel.setShowAllRoomsMeetings(!filterViewModel.showAllRoomsMeetings);
  }, []);

  const panelWraperClassName = useMemo(
    () => `panel-wrapper ${filterViewModel.openPanel ? 'open' : ''}  ${isFixedPanel ? 'fixed' : ''}`,
    [filterViewModel.openPanel, isFixedPanel],
  );

  const getDayClassName = useCallback((day: Date) => (calendarViewModel.isChoosedDay(day) ? 'choosed-day' : ''), [calendarViewModel.today]);

  const moveToPrevMonth = useCallback(() => calendarViewModel.movingBeetweenCalendarData('prev', 'month'), []);

  const moveToNextMonth = useCallback(() => calendarViewModel.movingBeetweenCalendarData('next', 'month'), []);

  return (
    <>
      <Drawer 
        theme={filterTheme} 
        variant="permanent" 
        open={filterViewModel.openPanel} 
        onClick={onClickDrawer}
      >
        <div className={panelWraperClassName}>
          <div className={`header ${filterViewModel.openPanel ? 'open' : ''}`}>
            {filterViewModel.openPanel
              ? <BigArrowLeft onClick={onClose} />
              : <BigArrowRight />}
          </div>
          <div className="blocks">
            {filterViewModel.openPanel
              ? (
                <>
                  <CalendarPreview
                    startDate={calendarViewModel.startInterval}
                    getDayClassName={getDayClassName}
                    moveToPrevMonth={moveToPrevMonth}
                    moveToNextMonth={moveToNextMonth}
                    onClickDay={calendarViewModel.setDay}
                  />

                  <Blocks 
                    isModerator={isModerator()}
                    roomsLoading={filterViewModel.roomsLoading}
                    rooms={filterViewModel.rooms}
                    selectRoomCabinetNumber={filterViewModel.selectRoomCabinetNumber}
                    onChooseRoom={onChooseRoom}
                    onChooseAllRooms={onChooseAllRooms}
                    showAllRoomsMeetings={filterViewModel.showAllRoomsMeetings}
                    isMembersLoading={filterViewModel.isMembersLoading}
                    selectEmployeeId={filterViewModel.selectEmployeeId}
                    members={filterViewModel.members}
                    onChooseEmployee={onChooseEmployee}
                    isCalendarsLoading={filterViewModel.isCalendarsLoading}
                    privateCalendars={filterViewModel.privateCalendars}
                    setCheckedCalendar={filterViewModel.setCheckedCalendar}
                    getColorByName={calendarColorStore.getColorByName}             
                  />
                </>
              )
              : (
                <>
                  {isModerator() ? (
                    <>
                      <MonthCalendarIcon />
                      <RoomsIcon />
                      <EmployeesIcon />
                      <PrivateCalendarsIcon />
                    </>
                  ) : (
                    <>
                      <MonthCalendarIcon />
                      <PrivateCalendarsIcon />
                      <EmployeesIcon />
                      <RoomsIcon />
                    </>
                  )}
                </>
              )}
          </div>
        </div>
      </Drawer>
    </>
  );
});
